import * as React from "react";
const IconMc = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 512 341.333"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path  d="M0 85.333h512v341.333H0z" />
    <path  d="M0 85.333h512V256H0z" />
  </svg>
);
export default IconMc;
